import type { DetectedMeeting, RecallDetectedMeeting } from '@highlight/common'

/**
 * Main → overlay: autopilot held off on a meeting the user was already in
 * during onboarding (see onboarding-auto-transcribe-gate.ts). The overlay asks
 * before transcribing, then explains that later meetings start on their own.
 */
export const FIRST_MEETING_AFTER_ONBOARDING_EVENT = 'meeting:started:first-after-onboarding'

export type FirstMeetingAfterOnboardingPayload = DetectedMeeting | RecallDetectedMeeting
